import { CardAssociacoes } from '@/global/components/CardAssociacoes'
import { useState } from 'react'
import { AdicionarCentroCustoFuncionario } from './Adicionar'
import { FuncionarioCentroCustoDataGrid } from './Datagrid'

interface Props {
    /** Exibe o botão de adicionar; desligado na tela de detalhes. */
    editable?: boolean
}

/** Aba de centros de custo de um funcionário já cadastrado. */
export default function TabCentroCusto({ editable = true }: Props) {
    const [isAdicionarAberto, setIsAdicionarAberto] = useState(false)

    return [
        <CardAssociacoes
            key="tabela"
            titulo="Centros de custo associados"
            tituloAdicionar="Adicionar centro de custo"
            onAdicionar={
                editable ? () => setIsAdicionarAberto(true) : undefined
            }
        >
            <FuncionarioCentroCustoDataGrid />
        </CardAssociacoes>,
        <AdicionarCentroCustoFuncionario
            key="adicionar"
            open={isAdicionarAberto}
            onClose={() => setIsAdicionarAberto(false)}
        />,
    ]
}
